import { render, staticRenderFns } from "./biPassFail.vue?vue&type=template&id=7d10b007&scoped=true&"
import script from "./biPassFail.vue?vue&type=script&lang=js&"
export * from "./biPassFail.vue?vue&type=script&lang=js&"
import style0 from "./biPassFail.vue?vue&type=style&index=0&id=7d10b007&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d10b007",
  null
  
)

export default component.exports